module.exports = __webpack_public_path__ + "static/media/victoriauni.87271867.png";